<span class="subtitle">
  <div class="text-navy-900 uppercase text-bold text-sm">
    @switch (entryType) {
      @case ('GeneralInfo') {
        <span> General Information </span>
      }
      @case ('General') {
        <div class="text-navy-900 uppercase text-bold text-sm">{{ text }} {{ index !== null ? index + 1 : '' }}</div>
      }
    }
  </div>
  <span
    class="icon-trash-x icon"
    [ngClass]="{
      hidden: showRemoveIcon() === false,
      disabled: disableRemoveEntry,
    }"
    (click)="removeEntry()"
  ></span>
</span>
